import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, CloseButton } from 'pcln-design-system'
import styled from 'styled-components'

const ModalContainer = styled(Box)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
`

const StyledCloseButton = styled(CloseButton)`
  &:hover {
      color: inherit;
  }
`

const ModalBox = styled(Box)`
  max-width: ${props => `${props.maxWidth}px;`}
  min-height: 413px;
  box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.2);
  margin-top: 70px;
`

export default class Modal extends React.Component {
  static defaultProps = {
    id: 'nyop-modal',
    maxWidth: 765
  }

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
    isUsingInnerRef: PropTypes.bool,
    maxWidth: PropTypes.number,
    id: PropTypes.string,
    children: PropTypes.node
  }

  constructor (props) {
    super(props)
    this.modalRef = React.createRef()
  }

  componentDidMount () {
    if (this.props.isUsingInnerRef) {
      document.addEventListener('mousedown', this.handleClickWhenModalOpen)
    }
  }

  componentWillUnmount () {
    if (this.props.isUsingInnerRef) {
      document.removeEventListener('mousedown', this.handleClickWhenModalOpen)
    }
  }

  handleClickWhenModalOpen = e => {
    const node = this.modalRef.current
    if ((node && node.contains(e.target)) || !this.props.show) return
    this.props.onClose()
  }

  render () {
    if (!this.props.show) {
      return null
    }

    return (
      <ModalContainer>
        <ModalBox
          innerRef={this.modalRef}
          id={this.props.id}
          p={4}
          color='background.lightest'
          m='auto'
          maxWidth={this.props.maxWidth}
        >
          <Flex>
            <Box mx='auto' />
            <StyledCloseButton onClick={this.props.onClose} />
          </Flex>
          <Box mt={3} pt={2}>
            {this.props.children}
          </Box>
        </ModalBox>
      </ModalContainer>
    )
  }
}
